import {PurchaseOrderItem, SourceMode, ToSourceItem} from "../../../../api/Logistics";
import {useContext} from "react";
import {Column, TableSelectionContext} from "../../../../misc/scroller/Table";
import {SnackContext} from "../../../../misc/Snackbar";
import {hasPermission, useUser} from "../../../../misc/Permission";
import {InfoIcon} from "./InfoIcon";
import {SimpleIconButton} from "../../../../misc/lists/SimpleIconButton";
import {api} from "../../../../api/API";
import {formatDescription} from "./SubmitButton";
import {purchasingPopoutPanel} from "../PurchaseOrderList";
import {toSourceTableName} from "../PartsToSource";
import AddCircle from "@mui/icons-material/AddCircle";
import {useSyncedRef} from "../../../../misc/SyncedRef";
import {useDropdownDataIMP} from "../../../project/settings/DropDowns";


export function useActionCol(props: {
    purchaseOrder?: number;
    configureSourceGroup?: number;
    sourceMode: SourceMode
    update?: (input: Partial<PurchaseOrderItem>, dt: ToSourceItem) => Partial<PurchaseOrderItem>
}) {
    const ctx = useContext(TableSelectionContext);
    const snack = useContext(SnackContext);
    const usr = useUser();
    const isRestockRef = useSyncedRef(props.sourceMode === "stock");
    const ddlOptionsRef = useDropdownDataIMP();

    return {
        name: "Actions",
        render: (dt: ToSourceItem, col: Column<ToSourceItem>) => (<div style={{display: "flex"}}>
            <InfoIcon row={dt} />
            {props.purchaseOrder && <div>
                <SimpleIconButton disabled={!hasPermission(usr, "CanReleaseAndPurchase") && usr?.id === dt.releasedBy} onClick={async () => {
                    if(!props.purchaseOrder) return;

                    try {
                        snack.loading();
                        const ddlOptions = await ddlOptionsRef.current();

                        let input: Partial<PurchaseOrderItem> = {
                            id: 0,
                            purchaseOrder: props.purchaseOrder,
                            reference: "",
                            description: formatDescription(dt, {ddlOptions}),
                            code: dt.productCode,
                            qty: dt.qty,
                            unitPriceCents: dt.lastPrice || dt.lastPriceAtOthers || 0,
                            inventoryRequests: dt.inventoryRequestId ? [dt.inventoryRequestId] : [],
                            archived: false,
                            updatedAt: (new Date()) as any,
                            kind: dt.kind as any,
                            qtyOutstanding: 0,
                            qtyPendingReceiving: 0,
                            qtyBackOrdered: 0,
                            createStockingInventoryRequestForProduct: isRestockRef.current ? dt.product : undefined,
                        }

                        if(props.update) {
                            input = props.update(input, dt)
                        }

                        await api.logistics.updatePurchaseOrderItem(input as any);

                        purchasingPopoutPanel.sendToServer("refresh-po");
                        ctx.refresh(toSourceTableName);
                        snack.success("Added")
                    } catch(e: any) {
                        snack.error(e.toString())
                    }
                }}>
                    <AddCircle />
                </SimpleIconButton>
            </div>}

            {props.configureSourceGroup && <div>
                <SimpleIconButton disabled={!hasPermission(usr, "CanReleaseAndPurchase") && usr?.id === dt.releasedBy} onClick={async () => {
                    if(!props.configureSourceGroup) return;

                    try {
                        snack.loading();

                        await api.configureSourcing.addItems({
                            group: props.configureSourceGroup,
                            inventoryRequests: [dt.id]
                        })

                        ctx.refresh(toSourceTableName);
                        snack.success("Added")
                    } catch(e: any) {
                        snack.error(e.toString())
                    }
                }}>
                    <AddCircle />
                </SimpleIconButton>
            </div>}
        </div>),
        width: 60,
    }
}
